<section class="hero section" id="about">
  <div class="hero__bg" aria-hidden="true">
    <video
      class="hero__bgMedia"
      #heroVideo
      autoplay
      muted
      loop
      playsinline
      preload="auto"
    >
      <source src="assets/shared/hero/video1.webm" type="video/webm" />
      <source src="assets/shared/hero/video1.mp4" type="video/mp4" />
    </video>
  </div>

  <div class="hero__overlay" aria-hidden="true"></div>
  <div class="hero__dog" aria-hidden="true">
    <img
      class="hero__dogImage"
      src="assets/shared/icons-svg/dog.svg"
      alt=""
      loading="lazy"
      decoding="async"
    />
  </div>

  <div class="shell-container hero__grid">
    <div class="hero__content">
      <div class="badge">
        <span class="hero__pulse"></span>
        {{ content.badge }}
      </div>

      <h1>
        {{ content.title }}
        <span class="hero__accent">{{ content.accent }}</span>
      </h1>

      <p class="hero__lede">
        {{ content.lede }}
      </p>

      <div class="hero__actions">
        <a
          *ngFor="let action of content.actions"
          class="btn"
          [ngClass]="{
            'btn--primary': action.variant === 'primary',
            'btn--ghost': action.variant === 'ghost'
          }"
          [href]="action.href"
        >
          {{ action.label }}
        </a>
      </div>

      <div class="hero__meta">
        <div *ngFor="let item of content.meta">
          <p class="meta__value">{{ item.title }}</p>
          <p class="meta__label">{{ item.description }}</p>
        </div>
      </div>
    </div>

    <div
      class="panel-slider"
      *ngIf="heroSlides.length > 0"
      role="region"
      aria-label="Hero feature slider"
      tabindex="0"
      (mouseenter)="pause()"
      (mouseleave)="resume()"
      (touchstart)="onTouchStart($event)"
      (touchend)="onTouchEnd($event)"
      (keydown)="onKeydown($event)"
    >
      <div
        class="panel-slider__track"
        [style.transform]="'translateX(-' + (currentIndex * 100) + '%)'"
      >
        <div
          class="panel-slider__slide"
          *ngFor="let s of heroSlides; let i = index"
          [attr.aria-hidden]="i !== currentIndex"
        >
          <div class="hero__panel">
            <div class="panel__card panel__card--primary">
              <p class="panel__title">{{ s.title }}</p>
              <p class="panel__body">{{ s.body }}</p>
              <div class="panel__tags">
                <span class="tag" *ngFor="let t of s.tags">{{ t }}</span>
              </div>
            </div>

            <div class="panel__row">
              <div class="panel__chip" *ngFor="let chip of s.chips | slice:0:2; let idx = index">
                <div class="chip__icon" [class.chip__icon--green]="idx === 1"></div>
                {{ chip }}
              </div>
            </div>

            <div class="panel__row">
              <div class="panel__chip" *ngFor="let chip of s.chips | slice:2:4; let idx = index">
                <div
                  class="chip__icon"
                  [class.chip__icon--amber]="idx === 0"
                  [class.chip__icon--rose]="idx === 1"
                ></div>
                {{ chip }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        class="panel-slider__nav panel-slider__nav--prev"
        type="button"
        (click)="prev()"
        aria-label="Previous slide"
      >
        &lsaquo;
      </button>
      <button
        class="panel-slider__nav panel-slider__nav--next"
        type="button"
        (click)="next()"
        aria-label="Next slide"
      >
        &rsaquo;
      </button>

      <div class="panel-slider__dots" role="tablist" aria-label="Slider dots">
        <button
          *ngFor="let s of heroSlides; let i = index"
          type="button"
          class="dot"
          [class.is-active]="i === currentIndex"
          (click)="goTo(i)"
          [attr.aria-label]="'Go to slide ' + (i + 1)"
        ></button>
      </div>
    </div>
  </div>
</section>
